(function() {
    'use strict';

    angular.module('app.principal', []);
})();
